import type { ButtonHTMLAttributes } from "react";

import { DisplayState } from "@/constants/state";
import { DefinedDefaults } from "@/ui/lib/types";
import { BUTTON_VARIANT_CLASS_MAP } from "@/ui/components/primitives/Button";
import type { TIconKey } from "@/ui/components/primitives/Icon";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const ICON_BUTTON_VARIANT_CLASS_MAP = {
  default: BUTTON_VARIANT_CLASS_MAP.default,
  secondary: BUTTON_VARIANT_CLASS_MAP.secondary,
  tertiary: BUTTON_VARIANT_CLASS_MAP.tertiary,
  destructive: BUTTON_VARIANT_CLASS_MAP.destructive,
} as const;

export const ICON_BUTTON_SIZE_CLASS_MAP = {
  default: "h-9 w-9 [&_svg]:size-4",
  sm: "h-8 w-8 [&_svg]:size-4",
  lg: "h-10 w-10 [&_svg]:size-4",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TIconButtonVariant = keyof typeof ICON_BUTTON_VARIANT_CLASS_MAP;
export type TIconButtonSize = keyof typeof ICON_BUTTON_SIZE_CLASS_MAP;

export type TIconButtonProps = {
  "aria-label": string;
  icon: TIconKey;
  size?: TIconButtonSize;
  state?: DisplayState;
  variant?: TIconButtonVariant;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-label" | "children">;

type TIconButtonDefaultProps = DefinedDefaults<
  TIconButtonProps,
  "variant" | "size"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const ICON_BUTTON_DEFAULTS = {
  variant: "default",
  size: "default",
} satisfies TIconButtonDefaultProps;
